import { Button } from '@/src/tailwindui/button';
import { Heading } from '@/src/tailwindui/heading';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/src/Authentication/components/hooks/useAuth';
import { Card } from '@/src/shadComponents/ui/card';
import { CardContent, CardHeader } from '@/src/shadComponents/ui/card';
export default function Welcome() {
    const navigate = useNavigate();
    const { auth } = useAuth();

    return (
        <div className="flex items-center h-screen justify-center dark:bg-[#262C2C] dark:text-white">
            <Card className="w-[90%] md:min-w-[600px] md:w-[600px] rounded-none shadow-none border-0 mb-[200px] md:mb-0">
                <CardHeader>
                    <Heading className="text-4xl plex-sans md:mb-10">
                        Hi, {auth?.firstName}.
                    </Heading>
                </CardHeader>
                <CardContent>
                    <Button
                        className="mt-6 black-button text-xl w-full"
                        onClick={() => navigate('/create-first-event')}
                    >
                        Let's get started&nbsp;&nbsp;&nbsp;&rarr;
                    </Button>
                    <Button
                        className="mt-6 white-button text-xl w-full shadow-none"
                        onClick={() => navigate('/')}
                    >
                        I'll do this later
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
